// extracted by mini-css-extract-plugin
export var tag = "tags-module--tag--485a4";
export var tags = "tags-module--tags--512d6";